import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Row from '@common/Row';
import Section from '@common/Section';
import Video from '@common/Video';
import Heading from '@common/Heading';

import Grid from '@images/grid-background.svg';

const GridBackground = ({ data }) => {
  const {
    title,
    showTitle,
    videoId,
    image,
    imageWidth
  } = data;
  return (
    <Section>
      <Container>
        <Row className='position-relative justify-content-center mt-5 mb-8'>
          <div className={clsx('col p-3', imageWidth)} style={{maxWidth: 990, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundImage: `url(${Grid})`}}>
            {(showTitle && title) && <Heading type='h2' className='text-center mb-4'>{title}</Heading>}
            <Video videoId={videoId} image={image}/>
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default GridBackground
